export default __webpack_public_path__ + "static/media/menupl.f2d6a3ac.svg";